import React, { useRef, useState } from "react";
import { Play, Pause, Volume2, VolumeX, Camera } from "lucide-react";
import { MEDIA } from "../mock/mock";

const Photos = () => {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [muted, setMuted] = useState(true);

  const togglePlay = () => {
    if (!videoRef.current) return;
    if (playing) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setPlaying(!playing);
  };

  const toggleMute = () => {
    if (!videoRef.current) return;
    videoRef.current.muted = !muted;
    setMuted(!muted);
  };

  return (
    <section id="photos" className="py-16 lg:py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        <div className="text-center mb-10">
          <span className="inline-block bg-[#25D366]/10 text-[#25D366] text-xs font-black tracking-widest px-3 py-1 rounded-full">
            EN IMAGES
          </span>
          <h2 className="mt-4 text-3xl md:text-4xl font-black text-[#0B2545]">
            Un aperçu de l&apos;expérience
          </h2>
          <p className="mt-3 text-slate-600 max-w-2xl mx-auto">
            Découvrez notre bateau et l&apos;ambiance à bord. Plus de photos très prochainement,
            dès les premières excursions !
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-6">
          {/* Video – 2 columns */}
          <div className="lg:col-span-2 relative rounded-3xl overflow-hidden shadow-2xl bg-[#0B2545] aspect-video group">
            <video
              ref={videoRef}
              src={MEDIA.video}
              className="absolute inset-0 w-full h-full object-cover"
              playsInline
              loop
              muted={muted}
              preload="metadata"
              onPlay={() => setPlaying(true)}
              onPause={() => setPlaying(false)}
              onClick={togglePlay}
            />

            {!playing && (
              <div
                onClick={togglePlay}
                className="absolute inset-0 bg-gradient-to-t from-[#0B2545]/70 via-[#0B2545]/20 to-transparent flex items-center justify-center cursor-pointer"
              >
                <div className="text-center">
                  <div className="relative inline-flex items-center justify-center">
                    <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" />
                    <button
                      aria-label="Lire la vidéo"
                      className="relative h-20 w-20 rounded-full bg-[#25D366] hover:bg-[#1EBE5D] flex items-center justify-center shadow-2xl transition-transform group-hover:scale-105"
                    >
                      <Play className="h-9 w-9 text-white ml-1" fill="white" />
                    </button>
                  </div>
                  <div className="mt-5 text-white font-black text-xl md:text-2xl drop-shadow">
                    Bienvenue à bord
                  </div>
                  <div className="text-white/80 text-sm mt-1">Cliquez pour découvrir</div>
                </div>
              </div>
            )}

            {/* Controls (visible when playing) */}
            {playing && (
              <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between">
                <button
                  onClick={togglePlay}
                  aria-label="Pause"
                  className="h-11 w-11 rounded-full bg-black/50 backdrop-blur hover:bg-black/70 flex items-center justify-center text-white transition"
                >
                  <Pause className="h-5 w-5" fill="white" />
                </button>
                <button
                  onClick={toggleMute}
                  aria-label={muted ? "Activer le son" : "Couper le son"}
                  className="h-11 w-11 rounded-full bg-black/50 backdrop-blur hover:bg-black/70 flex items-center justify-center text-white transition"
                >
                  {muted ? <VolumeX className="h-5 w-5" /> : <Volume2 className="h-5 w-5" />}
                </button>
              </div>
            )}
          </div>

          {/* Right column: 2 stacked cards */}
          <div className="grid grid-rows-2 gap-6">
            <div className="relative rounded-3xl overflow-hidden shadow-xl group">
              <img
                src={MEDIA.sunset}
                alt="Coucher de soleil depuis le bateau"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 min-h-[220px]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B2545]/80 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-5 right-5">
                <div className="text-[#FFC93C] text-[10px] font-black tracking-widest">SORTIE COUCHER DE SOLEIL</div>
                <div className="text-white font-black text-lg leading-tight">La magie de la Guadeloupe au crépuscule</div>
              </div>
            </div>

            <div className="relative rounded-3xl overflow-hidden shadow-xl bg-gradient-to-br from-[#0B2545] to-[#134074] p-6 flex flex-col justify-between min-h-[220px]">
              <div className="absolute -top-8 -right-8 h-32 w-32 rounded-full bg-[#FFC93C]/20 blur-2xl" />
              <div className="relative">
                <div className="inline-flex items-center gap-2 bg-[#FFC93C]/20 text-[#FFC93C] text-[10px] font-black tracking-widest px-2.5 py-1 rounded-full">
                  <Camera className="h-3 w-3" /> BIENTÔT
                </div>
                <h3 className="mt-3 text-white font-black text-lg leading-tight">
                  Plus de photos très prochainement
                </h3>
                <p className="mt-2 text-white/70 text-sm leading-relaxed">
                  Dès nos premières excursions, retrouvez ici les moments forts capturés à bord :
                  mangrove, snorkeling, îlets et repas les pieds dans l&apos;eau.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Photos;
